import { Platform, type StyleProp, type ViewStyle } from 'react-native';
import { spacing } from '../../shared/theme/public-api';

/** Espacio reservado por la barra de pestañas para que el último ítem no quede tapado. */
export const TAB_BAR_CLEARANCE = 56;

const DEFAULT_WEB_EXTRA_BOTTOM = 16;

export type TabBarListContentStyleOptions = {
  bottomInset: number;
  /** Padding extra en web (p. ej. catálogo/inventario). */
  webExtraBottom?: number;
  /** Cuando la lista está vacía, el contenedor puede crecer para centrar el empty state. */
  emptyGrowStyle?: StyleProp<ViewStyle>;
  baseContentStyle?: StyleProp<ViewStyle>;
};

/** Padding inferior consistente en listas operativas bajo la tab bar. */
export function tabBarListContentStyle({
  bottomInset,
  webExtraBottom = DEFAULT_WEB_EXTRA_BOTTOM,
  emptyGrowStyle,
  baseContentStyle,
}: TabBarListContentStyleOptions): StyleProp<ViewStyle> {
  return [
    baseContentStyle,
    emptyGrowStyle,
    {
      paddingBottom:
        spacing.xxl +
        bottomInset +
        TAB_BAR_CLEARANCE +
        (Platform.OS === 'web' ? webExtraBottom : 0),
    },
  ];
}
